import {getLocaleInputFormats} from 'util/DateUtil';

import {Optional} from './Types';

export const USER_EDIT_DATE_FORMAT = 'YYYY-MM-DD';
export const USER_EDIT_LOCAL_DATETIME_FORMAT = 'YYYY-M-D h:m:s a';
export const PRESENTATIONAL_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm:ss A';
export const USER_EDIT_TIME_FORMAT = 'h:m a';
export const PRESENTATIONAL_TIME_FORMAT = 'hh:mm A';
export const CANONICAL_FORMAT = 'YYYY-MM-DDTHH:mm:ssZZ'; // What the server expects
export const USER_EDIT_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const INPUT_FORMATS = [
  'YYYY-M-D',
  'YYYY-MM-DD',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD HH:mm ZZ',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DD HH:mm:ss ZZ',
  CANONICAL_FORMAT,
  USER_EDIT_DATETIME_FORMAT,
  USER_EDIT_DATE_FORMAT,
];

export function asyncTryParseDate(
  text: string,
  languageTag?: Optional<string>,
  timezoneName?: Optional<string>
): Promise<string | null> {
  // This is a large library and not needed often so we rely on an async import to reduce bundle size
  return import('moment-timezone').then((momentTz) => {
    const parsed = momentTz.tz(
      text,
      [USER_EDIT_DATE_FORMAT, ...getLocaleInputFormats(/* includeTime */ false, languageTag)],
      true,
      timezoneName || momentTz.tz.guess()
    );
    return parsed.isValid() ? parsed.format(USER_EDIT_DATE_FORMAT) : null;
  });
}

export function asyncTryParse(
  text: string,
  languageTag?: Optional<string>,
  timezoneName?: Optional<string>
): Promise<string | null> {
  // This is a large library and not needed often so we rely on an async import to reduce bundle size
  return import('moment-timezone').then((momentTz) => {
    const parsed = momentTz.tz(
      text.trim(),
      [...getLocaleInputFormats(/* includeTime */ true, languageTag), ...INPUT_FORMATS],
      /* strict */ true,
      timezoneName || momentTz.tz.guess()
    );
    return parsed.isValid() ? parsed.format(CANONICAL_FORMAT) : null;
  });
}

/**
 * @param {string} text: Representation of date-time value
 * @param {string} languageTag: Locale for date-time string value
 * @returns String representation for date value (with time value stripped)
 */
export function asyncTryParseDatetimeAsDate(
  text: string,
  languageTag?: Optional<string>,
  timezoneName?: Optional<string>
): Promise<string | null> {
  // This is a large library and not needed often so we rely on an async import to reduce bundle size
  return import('moment-timezone').then((momentTz) => {
    const parsed = momentTz.tz(
      text.trim(),
      [...getLocaleInputFormats(/* includeTime */ true, languageTag), ...INPUT_FORMATS],
      /* strict */ true,
      timezoneName || momentTz.tz.guess()
    );
    return parsed.isValid() ? parsed.format(USER_EDIT_DATE_FORMAT) : null;
  });
}
